// 採点用紙（Judging Sheet）PDF出力まわりの共通ユーティリティ

export const ENTRY_CLASS_LABELS: { [key: string]: string } = {
  QuartetContest: "Quartet Contest",
  ChorusContest: "Chorus Contest",
  EvaluationOnly: "Evaluation Only",
};

export const getEntryClassLabel = (entryClass: string): string =>
  ENTRY_CLASS_LABELS[entryClass] ?? entryClass;

// 出力日（当日の日付）を yyyy/MM/dd 形式で返す
export const formatTodayDate = (): string => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");

  return `${yyyy}/${mm}/${dd}`;
};

// 基本情報（Summary）に登録されている開催日（Firestore Timestamp）を
// yyyy/MM/dd 形式に変換する。未登録の場合は空文字を返す。
export const formatDateFromTimestamp = (
  timestamp?: { toDate: () => Date } | null,
): string => {
  if (!timestamp) return "";

  const date = timestamp.toDate();
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");

  return `${yyyy}/${mm}/${dd}`;
};
